import React, { useState, useEffect } from 'react';
import { Container, Typography, Grid, TextField, Button, Box, FormControl, InputLabel,
  Select, MenuItem, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import OrganizationsHeader from '../dashboardnavebar';

const HireTalent = () => {
  const navigate = useNavigate();
  const [formErrors, setFormErrors] = useState({});
  const [formData, setFormData] = useState({
    experience: [],
    domain: [],
    roleOverview: '',
    responsibilities: '',
    deliverables: '',
    skills: '',
    preferredBackground: '',
    stipendOrSalary: '',
    applicationDeadline: '',
    joiningDate: '',
    contactName: '',
    contactEmail: '',
    contactPhone: '',
    linkedInProfile: '',
  });

  useEffect(() => {
    const stored = localStorage.getItem('hireTalentData');
    if (stored) {
      const parsed = JSON.parse(stored);
      setFormData((prev) => ({ ...prev, ...parsed }));
    }
  }, []);

  // const handleChange = (e) => {
  //   const { name, value } = e.target;

  const handleChange = (e) => {
  const { name, value } = e.target;
  setFormData((prev) => ({
    ...prev,
    [name]: typeof value === 'string' ? value.split(',') : value,
  }));

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Remove error for the current field if it exists
    if (formErrors[name]) {
      setFormErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[name];
        return updatedErrors;
      });
    }
  };

  const handleSave = (e) => {
    e.preventDefault();
    const errors = {};
    if (!formData.experience) errors.experience = 'Minimum Experience is required';
    if (!formData.domain) errors.domain = 'Domain is required';
    if (!formData.roleOverview) errors.roleOverview = 'Role Overview is required';
    if (!formData.responsibilities) errors.responsibilities = 'Responsibilities are required';
    if (!formData.deliverables) errors.deliverables = 'Deliverables are required';
    if (!formData.skills) errors.skills = 'Skills are required';
    if (!formData.preferredBackground) errors.preferredBackground = 'Preferred Background is required';
    if (!formData.stipendOrSalary) errors.stipendOrSalary = 'Stipend or Salary is required';
    if (!formData.applicationDeadline) errors.applicationDeadline = 'Application Deadline is required';
    if (!formData.joiningDate) errors.joiningDate = 'Joining Date is required';
    if (!formData.contactEmail) errors.contactEmail = 'Contact Email is required';

    setFormErrors(errors);
    if (Object.keys(errors).length > 0) return;

    const stored = JSON.parse(localStorage.getItem('hireTalentData')) || {};
    localStorage.setItem('hireTalentData', JSON.stringify({ ...stored, ...formData }));
    navigate('/organizations/hire-tech-talent-submit');
  };

  return (
    <div className="students-flex">
      <OrganizationsHeader />
      <Box
        sx={{
          background: 'linear-gradient(to right, #e0f7fa, #f1f8e9)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start',
          height : '91vh',
          overflowY: 'auto',
          padding: "40px"
        }}
      >
        <Container maxWidth="md">
          <Paper
            elevation={4}
            sx={{
              p: { xs: 3, md: 5 },
              borderRadius: 4,
              background: '#ffffff',
            }}
          >
            <Box sx={{ mt: 4 }}>
              <Grid container spacing={3}>
                {/* SECTION 3: ROLE DETAILS */}
                <Grid item xs={12}>
                  <Typography variant="h5" gutterBottom sx={{ fontSize: { xs: '1.25rem', sm: '1.5rem' } }}>
                    Section 3: Role Details
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel sx={{ fontSize: { xs: '0.85rem', sm: '1rem' } }}>Experience</InputLabel>
                    <Select
                      multiple
                      name="experience"
                      value={formData.experience}
                      error={Boolean(formErrors.experience)}
                      onChange={handleChange}
                      label="Experience"
                      renderValue={(selected) => selected.join(', ')}
                      sx={{
                        fontSize: { xs: '0.875rem', sm: '1rem' },
                      }}
                    >
                      <MenuItem value="">Select Experience</MenuItem>
                      <MenuItem value="Students">Students</MenuItem>
                      <MenuItem value="Fresher">Fresher</MenuItem>
                      <MenuItem value="1-2 years">1-2 years</MenuItem>
                      <MenuItem value="2-5 years">2-5 years</MenuItem>
                      <MenuItem value="5+ years">5+ years</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel sx={{ fontSize: { xs: '0.85rem', sm: '1rem' } }}>Domain / Functional Area</InputLabel>
                    <Select
                      multiple
                      name="domain"
                      value={formData.domain}
                      error={Boolean(formErrors.domain)}
                      onChange={handleChange}
                      label="Domain / Functional Area"
                      renderValue={(selected) => selected.join(', ')}
                      sx={{
                        fontSize: { xs: '0.875rem', sm: '1rem' },
                      }}
                    >
                      <MenuItem value="IoT">IoT</MenuItem>
                      <MenuItem value="Embedded Systems">Embedded Systems</MenuItem>
                      <MenuItem value="Data Science">Data Science</MenuItem>
                      <MenuItem value="AI/ML">AI/ML</MenuItem>
                      <MenuItem value="Web/Mobile Development">Web/Mobile Development</MenuItem>
                      <MenuItem value="Cybersecurity">Cybersecurity</MenuItem>
                      <MenuItem value="DevOps">DevOps</MenuItem>
                      <MenuItem value="Other">Other</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    label="Role Overview"
                    name="roleOverview"
                    value={formData.roleOverview}
                    onChange={handleChange}
                    fullWidth
                    multiline
                    rows={3}
                    placeholder="Brief overview of the opportunity, role expectations"
                    error={Boolean(formErrors.roleOverview)}
                    helperText={formErrors.roleOverview}
                    sx={{
                      fontSize: { xs: '0.875rem', sm: '1rem' },
                    }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    label="Key Responsibilities / Tasks"
                    name="responsibilities"
                    value={formData.responsibilities}
                    onChange={handleChange}
                    fullWidth
                    multiline
                    error={Boolean(formErrors.responsibilities)}
                    helperText={formErrors.responsibilities}
                    rows={3}
                    placeholder="Detailed responsibilities/tasks"
                    sx={{
                      fontSize: { xs: '0.875rem', sm: '1rem' },
                    }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    label="Deliverables / Output Expectations"
                    name="deliverables"
                    value={formData.deliverables}
                    onChange={handleChange}
                    error={Boolean(formErrors.deliverables)}
                    helperText={formErrors.deliverables}
                    fullWidth
                    multiline
                    rows={2}
                    placeholder="Specify key deliverables"
                    sx={{
                      fontSize: { xs: '0.875rem', sm: '1rem' },
                    }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    label="Skill Requirements / Tools"
                    name="skills"
                    value={formData.skills}
                    error={Boolean(formErrors.skills)}
                    helperText={formErrors.skills}
                    onChange={handleChange}
                    fullWidth
                    multiline
                    rows={2}
                    placeholder="List relevant tools, frameworks, and libraries"
                    sx={{
                      fontSize: { xs: '0.875rem', sm: '1rem' },
                    }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    label="Preferred Technical Background"
                    name="preferredBackground"
                    value={formData.preferredBackground}
                    onChange={handleChange}
                    error={Boolean(formErrors.preferredBackground)}
                    helperText={formErrors.preferredBackground}
                    fullWidth
                    placeholder="e.g., B.Tech in ECE or prior IoT experience"
                    sx={{
                      fontSize: { xs: '0.875rem', sm: '1rem' },
                    }}
                  />
                </Grid>

                {/* SECTION 4: COMPENSATION & DATES */}
                <Grid item xs={12}>
                  <Typography variant="h5" gutterBottom sx={{ fontSize: { xs: '1.25rem', sm: '1.5rem' } }}>
                    Section 4: Compensation & Dates
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Stipend / Salary"
                    name="stipendOrSalary"
                    value={formData.stipendOrSalary}
                    onChange={handleChange}
                    error={Boolean(formErrors.stipendOrSalary)}
                    helperText={formErrors.stipendOrSalary}
                    fullWidth
                    placeholder="e.g., ₹10,000/month or Unpaid"
                    sx={{
                      fontSize: { xs: '0.875rem', sm: '1rem' },
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Application Deadline"
                    name="applicationDeadline"
                    type="date"
                    value={formData.applicationDeadline}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                    error={Boolean(formErrors.applicationDeadline)}
                    helperText={formErrors.applicationDeadline}
                    fullWidth
                    sx={{
                      fontSize: { xs: '0.875rem', sm: '1rem' },
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Expected Joining Date"
                    name="joiningDate"
                    type="date"
                    value={formData.joiningDate}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                    error={Boolean(formErrors.joiningDate)}
                    helperText={formErrors.joiningDate}
                    fullWidth
                    sx={{
                      fontSize: { xs: '0.875rem', sm: '1rem' },
                    }}
                  />
                </Grid>

                {/* SECTION 5: CONTACT INFORMATION */}
                <Grid item xs={12}>
                  <Typography variant="h5" gutterBottom sx={{ fontSize: { xs: '1.25rem', sm: '1.5rem' } }}>
                    Section 5: Contact Information
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Contact Person Name"
                    name="contactName"
                    value={formData.contactName}
                    onChange={handleChange}
                    fullWidth
                    sx={{
                      fontSize: { xs: '0.875rem', sm: '1rem' },
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Contact Email"
                    name="contactEmail"
                    value={formData.contactEmail}
                    error={Boolean(formErrors.contactEmail)}
                    helperText={formErrors.contactEmail}
                    onChange={handleChange}
                    fullWidth
                    sx={{
                      fontSize: { xs: '0.875rem', sm: '1rem' },
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Contact Phone Number"
                    name="contactPhone"
                    value={formData.contactPhone}
                    onChange={handleChange}
                    fullWidth
                    sx={{
                      fontSize: { xs: '0.875rem', sm: '1rem' },
                    }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    label="LinkedIn Profile (Optional)"
                    name="linkedInProfile"
                    value={formData.linkedInProfile}
                    onChange={handleChange}
                    fullWidth
                    placeholder="https://linkedin.com/in/..."
                    sx={{
                      fontSize: { xs: '0.875rem', sm: '1rem' },
                    }}
                  />
                </Grid>
              </Grid>

              <Box mt={4} display="flex" justifyContent="space-between">
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={() => navigate('/organizations/hire-tech-talent')}
                >
                  Back
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSave}
                >
                  Save & Continue
                </Button>
              </Box>
            </Box>
          </Paper>
        </Container>
      </Box>
    </div>
  );
};

export default HireTalent;
